var map = {
	"./A8.svg": 23907,
	"./A9.svg": 9266,
	"./F.svg": 8006,
	"./arrow-down.svg": 78928,
	"./arrow-left.svg": 53471,
	"./arrow-solid-down.svg": 91926,
	"./battle-add-crude.svg": 19346,
	"./battle-add.svg": 24172,
	"./battle-reduce.svg": 64298,
	"./close1.svg": 30501,
	"./defect-picture.svg": 41178,
	"./guanji.svg": 58718,
	"./steam.svg": 4992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22819;